import React, { useState, useEffect } from 'react';
import axios from "axios";
import css from "./ETFs.css";
import { getLan } from "../../stores/utils/utilities";
import { IntlProvider, defineMessages, FormattedMessage } from "react-intl";

import LogoETFs from "../../assets/images/BIVAETF.png";
import TickerTapeWidget from "../../components/ui/tradingviewWidget/TickerTapeWidget";
import MarketDataWidget from "../../components/ui/tradingviewWidget/MarketDataWidget";
import HeatMapETFWidget from "../../components/ui/tradingviewWidget/HeatMapETFWidget";
import TopStoriesWidget from "../../components/ui/tradingviewWidget/TopStoriesWidget";
import VideoPlayerPaged from "../../components/videos/VideoPlayerPaged";

import NuevosListados from "./NuevosListados";
import TarjetasEducativas from "./TarjetasEducativas";
import Eventos from "./Eventos";
import Top from "./Top"

const lang = getLan();
const videoKeyword = "ETFs";
const defaultVideoId = "Lij7oUkiZuY";
const dominio = process.env.REACT_APP_DOMINIO;

function ETFs() {
  let [textos, setTextos] = useState({});
  let [tickerTapeSymbols, setTickerTapeSymbols] = useState([]);
  let [monitorSymbols, setMonitorSymbols] = useState([]);

  useEffect(() => {
    let urlTexts = `${dominio}/cms/o/text/page/109/lang/${lang}`;
    axios.get(urlTexts)
      .then(response => {
        setTextos(defineMessages(response.data));
      })
      .catch(err => console.log(err));

    let urlTickerTape = `${dominio}/cms/o/statistics/etfs/cintillo`;
    axios.get(urlTickerTape)
      .then(response => {
        setTickerTapeSymbols(transformResponseForTickerTape(response.data));
      })
      .catch(err => console.log(err));

    let urlMonitor = `${dominio}/cms/o/statistics/etfs/monitor`;
    axios.get(urlMonitor)
      .then(response => {
        let output = [];
        let symbols = {};
        symbols.name = "ETFs";
        symbols.symbols = transformResponseForMonitor(response.data);
        output.push(symbols);
        setMonitorSymbols(output);
      })
      .catch(err => console.log(err));
  }, []);

  let transformResponseForTickerTape = response => {
    let responseForTV = [];
    response.forEach(element => {
      let ticker = {};
      ticker.proName = transformToTVFormat(element.clave, element.serie);
      responseForTV.push(ticker);
    });
    return responseForTV;
  };

  let transformResponseForMonitor = response => {
    let responseForTV = [];
    response.forEach(element => {
      let ticker = {};
      ticker.name = transformToTVFormat(element.clave, element.serie);
      ticker.displayName = element.razonSocial;
      responseForTV.push(ticker);
    });
    return responseForTV;
  };

  let transformToTVFormat = (clave, serie) => {
    let serieTV = serie && serie !== '*' ? `/` + serie.trim() : "";
    return `BIVA:${clave.trim()}${serieTV}`;
  };

  return (
    <IntlProvider locale={lang} messages={textos} onError={() => {}}>
      <div className="row">

        <div className="col-12 sin_padding">
          <div className="col-12 margen_top_30">
            <img src={LogoETFs} alt="etfs" className={css.logoETFs} />
          </div>
          {
            tickerTapeSymbols.length > 0 ?
            <div className={["col-12", css.fondo, css.topAndBottomDivider, css.tickerTape].join(" ")}>
              <TickerTapeWidget locale={lang} displayMode="compact" symbols={tickerTapeSymbols} />
            </div> : ""
          }
        </div>

        <div className={`col-12 ${css.contenido_principal}`}>
          <div className="row col-12 margen_top_20">
            <div className={[css.fondo, css.rightDivider, "col-lg-8 col-md-12 col-sm-12 col-xs-12"].join(" ")}>
              <h1 className={css.title}><FormattedMessage id="etfs.videos.titulo" defaultMessage="Videos Relevantes" /></h1>
              <VideoPlayerPaged videoKeyword={videoKeyword} defaultVideoId={defaultVideoId} videosPerPage={3}/>
            </div>
            <div className={[css.fondo, "col-lg-4 col-md-12 col-sm-12 col-xs-12"].join(" ")} >
              <h1 className={css.title}><FormattedMessage id="etfs.top.titulo" defaultMessage="Top ETFs" /></h1>
              <Top locale={lang}/>
            </div>
          </div>

          <div className={[css.bottomDivider, "row col-12 margen_top_10 margen_abajo"].join(" ")}></div>

          <div className="row col-12">
            <div className={[css.fondo, css.rightDivider, css.nuevosListados, "col-lg-6 col-md-12 col-sm-12 col-xs-12"].join(" ")}>
              <h1 className={css.title}><FormattedMessage id="etfs.nuevosListados.titulo" defaultMessage="Nuevos Listados" /></h1>
              <NuevosListados lang={lang} />
            </div>
            <div className={[css.fondo, "col-lg-6 col-md-12 col-sm-12 col-xs-12"].join(" ")} >
              <h1 className={css.title}><FormattedMessage id="etfs.eventos.titulo" defaultMessage="Eventos" /></h1>
              <Eventos lang={lang} />
            </div>
          </div>

          {
            monitorSymbols.length > 0 ? <>
            <div className={[css.bottomDivider, "row col-12 margen_top_10 margen_abajo"].join(" ")}></div>

            <div className="row col-12">
              <div className={`${css.fondo} col-12`}>
                <h1 className={css.title}><FormattedMessage id="etfs.monitor.titulo" defaultMessage="Monitor ETFs" /></h1>
                <MarketDataWidget widgetStyle={css.marketDataWidget} symbolsGroups={monitorSymbols} locale={lang}/>
              </div>
            </div> </> : ""
          }

          <div className={[css.bottomDivider, "row col-12 margen_top_10 margen_abajo"].join(" ")}></div>

          <div className="row col-12">
            <div className={[css.fondo, "col-12 "].join(" ")}>
              <h1 className={[css.title, "col-12 row"].join(" ")}><FormattedMessage id="etfs.educacional.titulo" defaultMessage="Sección Educativa" /></h1>
              <div className={["col-12 "].join(" ")}>
                <TarjetasEducativas lang={lang} />
              </div>
            </div>
          </div>

          <div className={[css.bottomDivider, "row col-12 margen_top_10 margen_abajo"].join(" ")}></div>

          <div className="row col-12">
            <div className={[css.fondo, "col-12 row"].join(" ")}>
              <h1 className={[css.title, "col-12 row"].join(" ")}><FormattedMessage id="etfs.mapaDeCalor.titulo" defaultMessage="Mapa de calor ETFs" /></h1>
              <HeatMapETFWidget style={css.heatMapETFWidget} locale={lang}/>
            </div>
          </div>

          <div className={[css.bottomDivider, "row col-12 margen_top_10 margen_abajo"].join(" ")}></div>

          <div className="row col-12">
            <div className={[css.fondo, "col-12 row"].join(" ")}>
              <TopStoriesWidget style={css.topStoriesWidget}/>
            </div>
          </div>
        </div>

        <div className="col-12 padding_bottom_100">
          {
            //Footer
          }
        </div>
      </div>
    </IntlProvider>
  );
}

export default ETFs;
